<template>
  <div class="view-contanier">
    <div class="header">
      <div class="tab">
        <span
          v-for="item in tabList"
          :key="item.permissson"
          v-permissson="`${item.permissson}`"
          :class="['tabItem', active === item.type ? 'active' : '']"
          @click="changeType(item.type, item.permissson)"
        >
          {{ item.name }}
          ({{ tabNumer.find((a) => a.type === item.type)?.qty || 0 }})
        </span>
      </div>
      <div class="opt">
        <div class="search">
          <el-input
            v-model="filterList.search"
            placeholder="请输入单号/参考单号搜索"
            class="input-search"
            @keydown.enter.native="search"
          ></el-input>
          <div class="btn-search" @click="search">
            <i class="el-icon-search"></i>
          </div>
        </div>
        <div
          v-show="computedPermissions('导出')"
          :v-permissson="computedPermissions('导出')"
          class="derive flex_c_c"
          @click="derive"
        >
          <img src="@/assets/images/const/derive.png" alt="导出" />
          导出
        </div>
        <div
          v-show="computedPermissions('新增')"
          :v-permissson="computedPermissions('新增')"
          class="add flex_c_c"
          @click="dialogVisible1 = true"
        >
          <svg-icon className="icon" iconClass="add" />新增
        </div>
        <BaseFilter
          :width="488"
          :isActive="isActive"
          @sendFilter="sendFilter"
          @reset="reset"
        >
          <el-form ref="form" :model="filterList" label-width="84px">
            <el-form-item label="创建时间">
              <el-date-picker
                v-model="filterList.date"
                style="width: 320px"
                type="daterange"
                range-separator="至"
                align="center"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                unlink-panels
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="进入时间">
              <el-date-picker
                v-model="filterList.entryDate"
                style="width: 320px"
                type="daterange"
                range-separator="至"
                align="center"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd"
                unlink-panels
                :picker-options="pickerOptions"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="客户">
              <el-select
                v-model="filterList.companyIds"
                style="width: 320px"
                placeholder="请选择类型"
                multiple
              >
                <el-option
                  v-for="item in companyDrapdown"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务类型">
              <el-select
                v-model="filterList.otherServiceTypeIds"
                style="width: 320px"
                placeholder="请选择类型"
                multiple
              >
                <el-option
                  v-for="item in otherServiceTypeOptions"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-form>
        </BaseFilter>
      </div>
    </div>
    <div class="data">
      <BaseTable
        v-if="height !== 0"
        :key="active"
        :height="height"
        :tableData="{
          ...tableData,
          fileds,
        }"
        :pageIndex="pager.pageIndex"
        :pageSize="pager.pageSize"
        :loading="loading"
        :isEmptyBorder="true"
        @handleSelectionChange="handleSelectionChange"
        @handlePageChange="handlePageChange"
        @sortChange="sortChange"
      >
        <template slot="attachmentCount" slot-scope="row">
          {{ row.scope.attachmentCount }}
          <img
            class="attachments"
            src="@/assets/images/other/attachments.png"
            @click="attachments(row.scope)"
          />
        </template>
        <div slot="otherServiceType" slot-scope="row" class="otherServiceType">
          <div
            v-for="item in row.scope.otherServiceType"
            :key="item.id"
            class="type-item flex_c_c"
          >
            {{ item.typeName }}
          </div>
        </div>
        <div
          slot="receivableStatus"
          slot-scope="row"
          :class="[
            'receivableStatus',
            'flex_c_c',
            `receivableStatus${row.scope.receivableStatus}`,
          ]"
        >
          {{ row.scope.receivableStatus | formartPayStatus }}
        </div>
        <div
          slot="payableStatus"
          slot-scope="row"
          :class="[
            'receivableStatus',
            'flex_c_c',
            `receivableStatus${row.scope.payableStatus}`,
          ]"
        >
          {{ row.scope.payableStatus | formartPayStatus }}
        </div>
        <span slot="receivableAmount" slot-scope="row" style="color: #fe453d">
          $ {{ row.scope.receivableAmount }}
        </span>
        <span slot="payableAmount" slot-scope="row" style="color: #fe453d">
          $ {{ row.scope.payableAmount }}
        </span>
        <div
          slot="auditStatus"
          slot-scope="row"
          :class="[
            'auditStatus',
            'flex_c_c',
            `auditStatus${row.scope.auditStatus}`,
          ]"
        >
          {{ row.scope.auditStatus | formartAuditStatus }}
        </div>
        <template slot="opt" slot-scope="row">
          <el-popover
            :ref="`popover${row.scope.id}`"
            placement="bottom-start"
            popper-class="pop-table-opt"
            width="114"
            trigger="click"
          >
            <div class="table-opt">
              <div>
                <el-button
                  v-show="computedPermissions('修改')"
                  :v-permissson="computedPermissions('修改')"
                  class="opt-item"
                  @click="update(row.scope)"
                >修改</el-button
                >
                <el-button
                  v-show="computedPermissions('作废')"
                  :v-permissson="computedPermissions('作废')"
                  class="opt-item"
                  @click="operat(row.scope, -1)"
                >作废</el-button
                >
                <el-button
                  v-show="computedPermissions('审核')"
                  :v-permissson="computedPermissions('审核')"
                  class="opt-item"
                  @click="operat(row.scope, 0)"
                >审核</el-button
                >
                <el-button
                  v-show="computedPermissions('反审核')"
                  :v-permissson="computedPermissions('反审核')"
                  class="opt-item"
                  @click="operat(row.scope, -2)"
                >反审核</el-button
                >
                <el-button
                  v-show="computedPermissions('完成')"
                  :v-permissson="computedPermissions('完成')"
                  class="opt-item"
                  @click="operat(row.scope, 1)"
                >完成</el-button
                >
                <el-button
                  v-show="computedPermissions('删除')"
                  :v-permissson="computedPermissions('删除')"
                  class="opt-item"
                  @click="deleteRow(row.scope)"
                >删除</el-button
                >
                <!-- <el-button
                  v-show="computedPermissions('明细')"
                  :v-permissson="computedPermissions('明细')"
                  class="opt-item"
                  @click="detail(row.scope)"
                >明细</el-button
                > -->
              </div>
            </div>
            <img
              slot="reference"
              style="margin-left: -14px"
              src="@/assets/images/table/opt.png"
            />
          </el-popover>
        </template>
        <template slot="custom-total">
          <div class="custom-total">
            <span>已选 {{ selectionItem.length }} 项</span>
            <div
              v-show="computedPermissions('批量完结')"
              :v-permissson="computedPermissions('批量完结')"
              class="flex_c_c finished"
              @click="batchComplete"
            >
              批量完结
            </div>
            <div
              v-show="computedPermissions('删除')"
              :v-permissson="computedPermissions('删除')"
              class="delete flex_c_c"
              @click="batchDelete"
            >
              <i class="el-icon-delete"></i>删除
            </div>
            <div
              v-show="computedPermissions('更新状态')"
              :v-permissson="computedPermissions('更新状态')"
              class="renewal flex_c_c"
              @click="renewal"
            >
              <img src="@/assets/images/other/renewal.png" />更新状态
            </div>
          </div>
        </template>
      </BaseTable>
    </div>
    <AddOtherServiceDialog
      :dialogVisible="dialogVisible1"
      :supplierOptions="supplierOptions"
      :otherServiceTypeOptions="otherServiceTypeOptions"
      :rowData="rowData"
      @cancel="cancel"
      @ok="ok"
    ></AddOtherServiceDialog>
    <AttachmentListDialog
      :dialogVisible="dialogVisible2"
      :rowData="rowData"
      @cancel="dialogVisible2 = false"
      @ok="ok"
    ></AttachmentListDialog>
    <RenewalStatusDialog
      :dialogVisible="dialogVisible3"
      :otherServiceIDs="selectionItem.map((a) => a.id)"
      @cancel="dialogVisible3 = false"
      @ok="ok"
    ></RenewalStatusDialog>
    <AuditFeeDialog
      :dialogVisible="dialogVisible4"
      :type="type"
      :rowData="rowData"
      @cancel="dialogVisible4 = false"
      @ok="ok"
    ></AuditFeeDialog>
    <BatchPaymentDialog
      :dialogVisible="dialogVisible5"
      :selectionItem="selectionItem"
      :type="10"
      @cancel="dialogVisible5 = false"
      @ok="ok"
    ></BatchPaymentDialog>
  </div>
</template>

<script>
const BaseTable = () => import('@/components/table/BaseTable')
const BaseFilter = () => import('@/components/filter/BaseFilter')
const BatchPaymentDialog = () =>
  import('@/components/dialog/BatchPaymentDialog.vue')
import AddOtherServiceDialog from './components/AddOtherServiceDialog'
import AttachmentListDialog from './components/AttachmentListDialog'
import RenewalStatusDialog from './components/RenewalStatusDialog'
import AuditFeeDialog from './components/AuditFeeDialog'
import { permissions, derive } from '@/utils/common'
import { getSupplierDropDownList } from '@/api/system'
import { mapGetters } from 'vuex'
import { myMixins } from '@/mixins'
import {
  getOtherServicePages,
  delOtherService,
  updateOtherServiceStatus,
  operatOtherService,
  getOtherServiceType,
  confirmServiceExpenses,
  complete
} from '@/api/other'
export default {
  name: 'OtherBusiness',
  components: {
    BaseTable,
    AddOtherServiceDialog,
    AttachmentListDialog,
    RenewalStatusDialog,
    BaseFilter,
    AuditFeeDialog,
    BatchPaymentDialog
  },
  filters: {
    formartPayStatus(v) {
      const obj = {
        0: '未录入',
        1: '已录入',
        2: '已审核',
        3: '已扣费'
      }
      return obj[v]
    },
    formartAuditStatus(v) {
      const obj = {
        0: '未审核',
        1: '已审核'
      }
      return obj[v]
    }
  },
  mixins: [myMixins],
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            }
          }
        ]
      },
      pager: {
        pageIndex: 1,
        pageSize: 20
      },
      active: 0,
      activeCode: '',
      tabList: [
        { name: '草稿箱', permissson: 'CGX', type: 0 },
        { name: '待审核', permissson: 'DSH', type: 1 },
        { name: '已审核', permissson: 'YSH', type: 3 },
        { name: '已完成', permissson: 'YWC', type: 4 },
        { name: '已作废', permissson: 'YZF', type: -1 }
      ],
      tableData: {
        columns: [],
        total: 0,
        mutiCheck: true,
        mutiFixed: 'left'
      },
      loading: false,
      height: 0,
      orderObj: {},
      tabNumer: [],
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      rowData: {},
      selectionItem: [],
      searchVal: '',
      filterList: {
        search: '',
        companyIds: [],
        otherServiceTypeIds: [],
        date: '',
        entryDate: ''
      },
      isActive: false,
      otherServiceTypeOptions: [],
      supplierOptions: [],
      type: 0
    }
  },
  computed: {
    ...mapGetters(['companyDrapdown']),
    computedPermissions() {
      return function(key) {
        const menuList = this.$store.getters.initRouter
        const menu = permissions(this.$route.meta.code, menuList)
        const presentTab = menu.children.find(
          (a) => a.code === this.activeCode,
        )
        const code = presentTab?.children?.find((a) => a.nameCH === key)?.code
        return code || ''
      }
    },
    fileds() {
      const fileds = [
        {
          filed: 'opt',
          label: '',
          width: '50px',
          isCustom: true,
          fixed: 'left'
        },
        {
          filed: 'serviceNo',
          label: '单号',
          align: 'left',
          isCopy: true,
          width: 180
        },
        {
          filed: 'companyName',
          label: '客户',
          align: 'left',
          width: 230
        },
        {
          filed: 'supplierName',
          label: '供应商',
          width: 150
        },
        {
          filed: 'cost',
          label: '成本',
          width: 150
        },
        {
          filed: 'otherServiceType',
          label: '业务类型',
          width: 160,
          isCustom: true,
          align: 'left'
        },
        {
          filed: 'referenceNumber',
          label: '客户参考单号1',
          isCopy: true,
          width: 160
        },
        {
          filed: 'referenceNumber2',
          label: '客户参考单号2',
          isCopy: true,
          width: 160
        },
        {
          filed: 'demandAdditional',
          label: '业务需求补充',
          width: 160
        },
        {
          filed: 'remark',
          label: '备注',
          width: 202
        },
        {
          filed: 'createdName',
          label: '创建人',
          width: 100
        },
        {
          filed: 'createdOn',
          label: '创建时间',
          width: 150,
          formatter: (row) =>
            row.createdOn
              ? row.createdOn.slice(0, row.createdOn.length - 3)
              : '',
          isSort: true
        },
        {
          filed: 'entryTime',
          label: '进入时间',
          width: 150,
          formatter: (row) =>
            row.entryTime
              ? row.entryTime.slice(0, row.entryTime.length - 3)
              : '',
          isSort: true
        }
      ]
      if (this.activeCode !== 'YZF') {
        fileds.push({
          filed: 'attachmentCount',
          label: '附件数',
          width: 100,
          isCustom: true
        })
      }
      return fileds
    }
  },
  created() {
    if (!this.companyDrapdown.length) {
      this.$store.dispatch('getCompanyDrapdown')
    }
  },
  mounted() {
    this.height = document.querySelector('.data').offsetHeight - 43
    if (!this.$store.state.connect.connect.tabCode) {
      const menuList = this.$store.getters.initRouter
      const menu = permissions(this.$route.meta.code, menuList)
      const codeLits = ['CGX', 'CLZ', 'YWC', 'YZF']
      const childrenCode = menu.children.map((a) => a.code)
      this.active = codeLits.findIndex((a) => childrenCode.includes(a))
      this.activeCode = menu.children[0].code
      this.getList(this.pager)
      this.getAddOtherServiceType()
      this.getCommData()
    }
  },
  methods: {
   async getCommData() {
     const res1 = await getSupplierDropDownList({ scopValue: 18 })
     const res2 = await getSupplierDropDownList({ scopValue: 19 })
     if (!res1.success) {
        this.$message.error(res1.errorMessage)
        return
     }
     if (!res2.success) {
        this.$message.error(res2.errorMessage)
        return
     }
     const arr = [...res1.data, ...res2.data].map(a => {
                  return {
              label: `${a.code}-${a.wbName}-${a.name}`,
              value: a.id
            }
     })
     const arrIDs = Array.from(new Set(arr.map(a => a.value)))
     const data = arrIDs.map(a => arr.find(b => b.value === a))
      this.supplierOptions = data
    },
    // async checkRow(row) {
    //   this.$confirm('审核该数据, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     iconClass: 'warning',
    //     showClose: false,
    //     closeOnPressEscape: false,
    //     closeOnClickModal: false,
    //     center: true
    //   })
    //     .then(() => {
    //       updateOtherServiceStatus({
    //        otherServiceIDs: [row.id],
    //         status: 3
    //       }).then((res) => {
    //         if (res.success) {
    //           this.$message.success('审核成功')
    //           this.initList()
    //         } else {
    //           this.$message.error(res.errorMessage)
    //         }
    //       })
    //     })
    //     .catch(() => {})
    // },
    // async reCheckRow(row) {
    //   this.$confirm('反审核该数据, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     iconClass: 'warning',
    //     showClose: false,
    //     closeOnPressEscape: false,
    //     closeOnClickModal: false,
    //     center: true
    //   })
    //     .then(() => {
    //       updateOtherServiceStatus({
    //        otherServiceIDs: [row.id],
    //         status: 1
    //       }).then((res) => {
    //         if (res.success) {
    //           this.$message.success('审核成功')
    //           this.initList()
    //         } else {
    //           this.$message.error(res.errorMessage)
    //         }
    //       })
    //     })
    //     .catch(() => {})
    // },
    changeType(type, code) {
      this.active = type
      this.activeCode = code
      const param = {
        pageIndex: 1,
        pageSize: this.pager.pageSize
      }
      this.pager = param
      this.selectionItem = []
      this.getList(param)
    },
    async getList(params) {
      this.loading = true
      try {
        params = {
          ...params,
          queryParam: {
            ...this.orderObj,
            ...this.formatterFilter()
          }
        }
        const res = await getOtherServicePages(params)
        this.loading = false
        if (res.success) {
          this.tableData.columns = res.data.list
          this.tableData.total = res.data.total
          this.tabNumer = res.data.tabNumer
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getAddOtherServiceType() {
      try {
        const res = await getOtherServiceType()
        if (res.success) {
          this.otherServiceTypeOptions = res.data
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    initList() {
      const param = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = param
      this.getList(param)
    },
    formatterFilter() {
      return {
        status: this.active === 6 ? -1 : this.active,
        search:
          this.filterList.search !== '' ? this.filterList.search : undefined,
        companyIds: this.filterList.companyIds.length
          ? this.filterList.companyIds
          : undefined,
        otherServiceTypeIds: this.filterList.otherServiceTypeIds.length
          ? this.filterList.otherServiceTypeIds
          : undefined,
        startDate:
          this.filterList.date !== '' ? this.filterList.date[0] : undefined,
        endDate:
          this.filterList.date !== '' ? this.filterList.date[1] : undefined,
        entryStartDate:
          this.filterList.entryDate !== ''
            ? this.filterList.entryDate[0]
            : undefined,
        entryEndDate:
          this.filterList.entryDate !== ''
            ? this.filterList.entryDate[1]
            : undefined
      }
    },
    sendFilter() {
      if (
        this.filterList.companyIds.length ||
        this.filterList.otherServiceTypeIds.length ||
        this.filterList.date !== '' ||
        this.filterList.entryDate !== ''
      ) {
        this.isActive = true
      } else {
        this.isActive = false
      }
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = params
      this.getList(params)
    },
    reset() {
      this.filterList = {
        companyIds: [],
        otherServiceTypeIds: [],
        date: '',
        entryDate: ''
      }
      // this.$refs.baseMutiInput.reset()
      this.isActive = false
    },
    handleSelectionChange(items) {
      this.selectionItem = items
    },
    handlePageChange(page) {
      this.pager = page
      this.getList(page)
    },
    sortChange(orderObj) {
      if (orderObj.order) {
        this.orderObj = {
          sortField: orderObj.prop,
          sortBy: orderObj.order === 'asc' ? 0 : 1
        }
      } else {
        this.orderObj = {}
      }
      this.getList(this.pager)
    },
    ok() {
      this.dialogVisible1 = false
      this.dialogVisible3 = false
      this.dialogVisible4 = false
      this.dialogVisible5 = false
      this.initList()
    },
    cancel() {
      this.rowData = {}
      this.dialogVisible1 = false
    },
    update(row) {
      this.rowData = row
      this.dialogVisible1 = true
    },
    attachments(row) {
      this.rowData = row
      this.dialogVisible2 = true
    },
    async deleteRow(row) {
      try {
        const res = await delOtherService([row.id])
        if (res.success) {
          this.$message.success(res.errorMessage)
          this.getList(this.pager)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async batchDelete() {
      if (this.selectionItem.length === 0) {
        this.$message.warning('请选择业务后再删除')
        return
      }
      try {
        const ids = this.selectionItem.map((a) => a.id)
        const res = await delOtherService(ids)
        if (res.success) {
          this.getList(this.pager)
          this.$message.success(res.errorMessage)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    async batchSend() {
      if (this.selectionItem.length === 0) {
        this.$message.warning('请选择业务后再发送')
        return
      }
      try {
        const otherServiceIDs = this.selectionItem.map((a) => a.id)
        const res = await updateOtherServiceStatus({
          status: 3,
          otherServiceIDs
        })
        if (res.success) {
          this.getList(this.pager)
          this.$message.success(res.errorMessage)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    operat(row, operatType) {
      const obj = {
        0: '审核',
        1: '完成',
        '-2': '反审核',
      '-1': '作废'
      }
      this.$confirm(
        `${obj[operatType]}单号${row.serviceNo}, 是否继续?`,
        `${obj[operatType]}提示`,
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          iconClass: 'warning',
          showClose: false,
          closeOnPressEscape: false,
          closeOnClickModal: false,
          center: true
        },
      )
        .then(async() => {
          try {
            const praams = {
              id: row.id,
              operatType
            }
            const res = await operatOtherService(praams)
            if (res.success) {
              this.getList(this.pager)
              this.$message.success(res.errorMessage)
            } else {
              this.$message.error(res.errorMessage)
            }
          } catch (error) {
            console.error(error)
          }
        })
        .catch(() => {})
    },
    derive() {
      const params = {
        ...this.formatterFilter()
      }
      derive('OtherService/exportOtherService', 'post', params)
    },
    search() {
      const params = {
        pageIndex: 1,
        pageSize: 20
      }
      this.pager = params
      this.getList(params)
    },
    renewal() {
      if (this.selectionItem.length === 0) {
        this.$message.warning('请选择业务后再更新')
        return
      }
      this.dialogVisible3 = true
    },
    audit(row, type) {
      this.rowData = row
      this.type = type
      this.dialogVisible4 = true
    },
    detail(row) {
      this.rowData = row
      this.dialogVisible4 = true
    },
    async confirm(row) {
      try {
        const res = await confirmServiceExpenses({ id: row.id })
        if (res.success) {
          this.$message.success(res.errorMessage)
          this.getList(this.pager)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.error(error)
      }
    },
    batchPayment() {
      if (!this.selectionItem.length) {
        this.$message.warning('请选择最少一条业务进行申付')
        return
      }
      const flag = this.selectionItem.every(
        (a) => a.supplierId === this.selectionItem[0].supplierId,
      )
      if (!flag) {
        this.$message.warning('所选业务供应商需要一致')
        return
      }
      this.dialogVisible5 = true
    },
    async batchComplete() {
      if (!this.selectionItem.length) {
        this.$message.error('未选择数据')
        return false
      }
      try {
        const res = await complete(this.selectionItem.map((a) => a.id))
        if (res.success) {
          this.$message.success('操作成功')
          this.getList(this.pager)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.view-contanier {
  width: 100%;
  padding: 0 10px;
  height: 100%;
  background: #fff;
  box-sizing: border-box;
  overflow: auto;
  .header {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .tabItem {
      padding: 15px 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
      box-sizing: border-box;
    }
    .active {
      color: rgb(18, 88, 188);
    }
    .opt {
      display: flex;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      & > div {
        height: 30px;
        box-sizing: border-box;
        margin-right: 5px;
        border-radius: 2px;
        cursor: pointer;
      }
      .search {
        position: relative;
        display: flex;
        width: 260px;
        .input-search {
          width: 226px;
          height: 30px !important;
          /deep/ .el-input__inner {
            height: 30px;
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
          }
        }
        .btn-search {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 30px;
          height: 30px;
          border: 1px solid #dbe4f2;
          border-left: 0;
          border-radius: 0 4px 4px 0;
          box-sizing: border-box;
          cursor: pointer;
          .el-icon-search {
            color: #666666;
          }
        }
      }
      .add {
        width: 80px;
        background: rgb(18, 88, 188);
        .icon {
          font-size: 20px;
        }
      }
      .derive {
        width: 80px;
        border: 1px solid rgb(18, 88, 188);
        color: rgb(18, 88, 188);
      }
    }
  }
  .data {
    width: 100%;
    height: calc(100% - 50px);
    .attachments {
      cursor: pointer;
    }
    .otherServiceType {
      display: flex;
      .type-item {
        height: 26px;
        background: rgba(37, 151, 244, 0.1);
        border-radius: 4px 4px 4px 4px;
        padding: 5px 3px;
        box-sizing: border-box;
        font-size: 12px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color: rgb(18, 88, 188);
        & + .type-item {
          margin-left: 5px;
        }
      }
    }
    .table-opt {
      display: flex;
      justify-content: space-around;
      span {
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: rgb(18, 88, 188);
        cursor: pointer;
        & + span {
          margin-left: 20px;
        }
      }
    }
    .custom-total {
      position: absolute;
      left: 0;
      display: flex;
      align-items: center;
      color: #999999;
      height: 42px;
      font-weight: 400;
      font-size: 14px;
      z-index: 1000;
      & > div {
        width: 80px;
        height: 30px;
        font-size: 14px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color: #999999;
        cursor: pointer;
        box-sizing: border-box;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #eeeeee;
        i,
        img {
          margin-right: 5px;
        }
      }
      .send {
        margin-left: 20px;
      }
      .delete {
        margin-left: 10px;
        .el-icon-delete {
          font-size: 16px;
          color: #999999;
        }
      }
      .renewal {
        margin-left: 20px;
        width: 100px;
      }
      .batchPayment {
        width: 100px;
        margin-left: 20px;
        border: 1px solid #35ba83;
        color: #35ba83;
      }
      .finished {
        width: 100px !important;
        margin-left: 20px;
        background: #ffffff !important;
        border: 1px solid #fe453d !important;
        color: #fe453d !important;
      }
    }
    .receivableStatus,
    .auditStatus {
      width: 60px;
      height: 26px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      margin: 0 auto;
      border-radius: 2px;
    }
    .receivableStatus0,
    .auditStatus0 {
      background: rgba(255, 116, 68, 0.1);
      color: rgba(255, 116, 68, 1);
    }
    .receivableStatus1 {
      background: rgba(35, 149, 243, 0.1);
      color: rgba(35, 149, 243, 1);
    }
    .receivableStatus2,
    .auditStatus1 {
      background: rgba(53, 186, 131, 0.1);
      color: rgba(53, 186, 131, 1);
    }
  }
}
</style>
